module.exports = {
      id: "rss-usage",
      viewBox: "0 0 13 12",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#rss",
      toString: function () {
        return this.url;
      }
    }